import React, { useContext } from 'react'

import { Header } from 'semantic-ui-react'

import { GlobalContext } from '../../contexts/GlobalContext'

const Title = ({ title, children: ActionBtns = null }: ITitle) => {
  const { isMobile } = useContext(GlobalContext)
  
  return (
    <>
      <div style={{
        display: 'flex',
        width: `calc(100% - ${isMobile ? '60px' : '240px'})`,
        height: isMobile ? 'auto' : '62px',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: isMobile ? 'column' : 'row',
        padding: '1rem 0',
        margin: '0',
        backgroundColor: '#13165a',
        boxSizing: 'border-box',
        position: 'fixed',
        top: '0',
        left: isMobile ? '60px' : '240px',
        zIndex: 999,
        boxShadow: 'none'
      }}>
        <Header as="h3" style={{ margin: 0, color: 'white', paddingLeft: '40px' }}>{title}</Header>
        <div style={{ display: 'flex', gap: '0.25rem', alignItems: 'center' }}>
          {ActionBtns && React.Children.map(ActionBtns, (child) =>
            React.cloneElement(child, {
              style: {
                ...child.props.style, 
                height: '100%',
                padding: '0.5rem 1rem',
                //outline: '1px solid white', 
                boxShadow: 'none', 
              }
            })
          )}
        </div>
      </div>
      <div
        style={{
          width: '100%',
          height: isMobile ? 'auto' : '62px'
        }}
      />
    </>
  )
}

interface ITitle {
  title: string
  children?: JSX.Element | null
}

export default Title
